import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const PinterestIcon: FunctionComponent<IconProps> = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath="url(#clip0_2785_91537)">
      <path d="M15.9999 2.47955e-05C7.16346 2.47955e-05 0 7.16351 0 16C0 22.7784 4.21731 28.573 10.1691 30.9043C10.0293 29.6384 9.9029 27.6915 10.2246 26.3095C10.5154 25.0608 12.1008 18.3565 12.1008 18.3565C12.1008 18.3565 11.6222 17.398 11.6222 15.981C11.6222 13.7562 12.9117 12.0952 14.5174 12.0952C15.8824 12.0952 16.5417 13.1201 16.5417 14.349C16.5417 15.7218 15.6677 17.7743 15.2167 19.6763C14.8397 21.2688 16.0153 22.5675 17.586 22.5675C20.4297 22.5675 22.6157 19.569 22.6157 15.2408C22.6157 11.4098 19.863 8.73135 15.9324 8.73135C11.3798 8.73135 8.70768 12.146 8.70768 15.6749C8.70768 17.05 9.23742 18.5246 9.89844 19.3263C10.0292 19.4847 10.0484 19.6235 10.0094 19.7852C9.88795 20.2905 9.61803 21.3773 9.56505 21.5997C9.49527 21.8926 9.33316 21.9548 9.02993 21.8136C7.03165 20.8835 5.78226 17.9618 5.78226 15.6152C5.78226 10.5681 9.44937 5.93287 16.3541 5.93287C21.9044 5.93287 26.2177 9.88801 26.2177 15.1737C26.2177 20.6879 22.7409 25.1257 17.9152 25.1257C16.2939 25.1257 14.7697 24.2834 14.248 23.2885C14.248 23.2885 13.4457 26.3434 13.2512 27.092C12.89 28.4817 11.9148 30.2238 11.2626 31.2865C12.7596 31.75 14.3505 32 15.9999 32C24.8365 32 32 24.8365 32 16C32 7.16351 24.8365 2.47955e-05 15.9999 2.47955e-05Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2785_91537">
        <rect width="32" height="32" fill="white" transform="matrix(1 0 0 -1 0 32)" />
      </clipPath>
    </defs>
  </svg>
)

export default PinterestIcon;


<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">

</svg>
